<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="_1-CN ParaOverride-7" id="_idParaDest-8"><span class="leading-139-5 CharOverride-12">P</span><span class="CharOverride-12">ART ONE</span></p>
<p class="PTS1_Part_subtitle_1_after_PT1">A PERFECT TEAM</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBookVR02457.vue?c5bda894